import "./ConnectSection.css"

function ConnectSection() {
  return (
    <section className="connect-section">
      <div className="connect-container">
        <h2 className="connect-title">Connect Salesforce & HubSpot Like Never Before</h2>
        <p className="connect-description">
          A seamless integration tool to sync your customer data, automate workflows, and boost productivity with
          real-time data synchronization between your favorite platforms.
        </p>
      </div>
    </section>
  )
}

export default ConnectSection
